import type { IconSvgObject } from './types';

const SirenIcon: IconSvgObject = [
  ["path", { d: "M4.99219 17V10C4.99219 6.13401 8.12619 3 11.9922 3C15.8582 3 18.9922 6.13401 18.9922 10V17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.4922 6.5C9.83533 6.5 8.49219 7.84315 8.49219 9.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2.99219 19C2.99219 17.8954 3.88762 17 4.99219 17H18.9922C20.0968 17 20.9922 17.8954 20.9922 19C20.9922 20.1046 20.0968 21 18.9922 21H4.99219C3.88762 21 2.99219 20.1046 2.99219 19Z", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export default SirenIcon;
